/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetNdpClientContractsResponse
 */
export interface GetNdpClientContractsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    birthNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    birthDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    mpk?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    contractNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    proposalNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    productType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    sourceSystem?: string | null;
}

/**
 * Check if a given object implements the GetNdpClientContractsResponse interface.
 */
export function instanceOfGetNdpClientContractsResponse(value: object): value is GetNdpClientContractsResponse {
    return true;
}

export function GetNdpClientContractsResponseFromJSON(json: any): GetNdpClientContractsResponse {
    return GetNdpClientContractsResponseFromJSONTyped(json, false);
}

export function GetNdpClientContractsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNdpClientContractsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'birthNumber': json['birthNumber'] == null ? undefined : json['birthNumber'],
        'birthDate': json['birthDate'] == null ? undefined : json['birthDate'],
        'mpk': json['mpk'] == null ? undefined : json['mpk'],
        'contractNumber': json['contractNumber'] == null ? undefined : json['contractNumber'],
        'proposalNumber': json['proposalNumber'] == null ? undefined : json['proposalNumber'],
        'productType': json['productType'] == null ? undefined : json['productType'],
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
    };
}

export function GetNdpClientContractsResponseToJSON(json: any): GetNdpClientContractsResponse {
    return GetNdpClientContractsResponseToJSONTyped(json, false);
}

export function GetNdpClientContractsResponseToJSONTyped(value?: GetNdpClientContractsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'surname': value['surname'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'birthNumber': value['birthNumber'],
        'birthDate': value['birthDate'],
        'mpk': value['mpk'],
        'contractNumber': value['contractNumber'],
        'proposalNumber': value['proposalNumber'],
        'productType': value['productType'],
        'sourceSystem': value['sourceSystem'],
    };
}

